import createMuiTheme from '@material-ui/core/styles/createMuiTheme';

import overrides from './overrides';
import clubeBlackOverrides from './clubeBlackTheme/overrides';
import overridesCustomizer from './overridesCustomizer';
import overridesMyProducts from './overridesMyProducts';
import variables from './variables';
import clubeBlackVariables from './clubeBlackTheme/variables';

const primary = {
  light: '#6d6d6d',
  main: '#122D44',
  dark: '#1b1b1b',
  contrastText: '#fff'
};

const secondary = {
  light: '#4ec485',
  main: '#0A3D61',
  dark: '#011b39',
  contrastText: '#fff'
};

const background = {
  default: '#fff'
};

export const theme = createMuiTheme({
  palette: { primary, secondary, background },
  typography: {
    useNextVariants: true
  },
  variables,
  overrides
});

export const clubeBlackTheme = createMuiTheme({
  palette: {
    primary: {
      light: '#ffffff',
      main: '#FAF8F8',
      dark: '#cccccc',
      contrastText: '#596375'
    },
    secondary: {
      light: '#4ec485',
      main: '#242424',
      dark: '#242424',
      contrastText: '#fff'
    },
    background
  },
  typography: {
    useNextVariants: true
  },
  variables: clubeBlackVariables,
  overrides: clubeBlackOverrides
});

export const whiteTheme = createMuiTheme({
  typography: {
    useNextVariants: true
  },
  palette: {
    primary: {
      light: '#ffffff',
      main: '#FAF8F8',
      dark: '#cccccc',
      contrastText: '#596375'
    },
    secondary: {
      light: '#4ec485',
      main: '#0A3D61',
      dark: '#011b39',
      contrastText: '#fff'
    }
  },
  variables,
  overrides
});

export const customizerTheme = createMuiTheme({
  typography: {
    useNextVariants: true
  },
  palette: {
    primary: {
      light: '#ffffff',
      main: '#FAF8F8',
      dark: '#192542',
      contrastText: '#596375'
    },
    secondary: {
      light: '#4ec485',
      main: '#0A3D61',
      dark: '#011b39',
      contrastText: '#fff'
    }
  },
  variables,
  overrides: overridesCustomizer
});

export const myProducts = createMuiTheme({
  typography: {
    useNextVariants: true
  },
  palette: {
    primary: {
      light: '#ffffff',
      main: '#000',
      dark: '#192542',
      contrastText: '#596375'
    },
    secondary: {
      light: '#4ec485',
      main: '#FFF',
      dark: '#011b39',
      contrastText: '#fff'
    }
  },
  variables,
  overrides: overridesMyProducts
});
